import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { getMaskIconStyles } from '@/styles/helpers';

export const DesktopHeaderItemsBox = styled.div`
  display: flex;
  align-items: center;
`;

export const DesktopHeaderRightActionLink = styled(CustomLink)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 44px;
  margin-right: 10px;
  border-radius: 7px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }

  &:nth-child(2) {
    margin-right: 20px;
  }
`;

export const DesktopHeaderRightActionIcon = styled.div<{
  $height: number;
  $filename: string;
  $isActive: boolean;
}>`
  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.palette.brand.main : theme.palette.primary.labels};

  ${({ $filename, $height }) => getMaskIconStyles($filename, 20, $height)};
`;

export const UnreadMessagesIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 8px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.palette.primary.background};
  background-color: ${({ theme }) => theme.palette.brand.main};
`;
